import { useAuth } from "@/hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string | string[];
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { user, currentUserLoading, clearAuthState } = useAuth();
  const location = useLocation();

  if (currentUserLoading) return null; // or a spinner

  if (!user) {
    // Clear all auth state, tokens, and cookies before redirecting
    clearAuthState();
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (requiredRole) {
    if (Array.isArray(requiredRole)) {
      if (!requiredRole.includes(user.role)) {
        // Redirect to appropriate dashboard based on user's role
        return <Navigate to={getDashboardPath(user.role)} />;
      }
    } else {
      if (user.role !== requiredRole) {
        // Redirect to appropriate dashboard based on user's role
        return <Navigate to={getDashboardPath(user.role)} />;
      }
    }
  }

  return <>{children}</>;
};

// Helper function to get the appropriate dashboard path based on user role
const getDashboardPath = (role: string): string => {
  switch (role) {
    case "company_admin":
      return "/admin/company";
    case "department_admin":
      return "/department-admin/dashboard";
    case "employee":
      return "/employee/dashboard";
    default:
      return "/dashboard";
  }
};

export default ProtectedRoute;
